// A uHoo room's CO2 row (dot by status, name, status text, ppm), used by the Energy air card and the Vent
// level card.
import * as React from 'react';

import { AirRoom } from '../../util/air';
import { Dot } from './card';
import { MUTED, SECONDARY } from './tokens';

export function AirRoomRow(props: { room: AirRoom; co2Label?: boolean }): React.ReactElement {
  const { room } = props;
  return (
    <div
      aria-label={`${room.name} CO2 ${room.co2} ppm, ${room.status}`}
      style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}
    >
      <Dot color={room.dot} />
      <span style={{ flex: 1, minWidth: 0 }}>
        {room.name}
        {props.co2Label && <span style={{ fontSize: 11, color: MUTED }}> CO₂</span>}
      </span>
      <span style={{ fontSize: 11, color: SECONDARY }}>{room.status}</span>
      <b className="num" style={{ width: props.co2Label ? 72 : 68, textAlign: 'right', whiteSpace: 'nowrap' }}>
        {room.co2} ppm
      </b>
    </div>
  );
}
